import {
    DEALERADDUPDATEDIVISONLIST_SUCCESS,
    DEALERADDUPDATEDIVISONLIST_FAILED,
    RESET_DEALERADDUPDATEDIVISONLIST,
    LOADING_DEALERADDUPDATEDIVISONLIST,
    NETWORK_ERROR_DEALERADDUPDATEDIVISONLIST
} from "../types/index"

import { dealerServices } from "../../config/axios";

const resetDealerAddUpdateDivisionList = () => {
    return { type: RESET_DEALERADDUPDATEDIVISONLIST };
};



const dealerAddUpdateDivisonList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERADDUPDATEDIVISONLIST });
    await dealerServices
        .post("divisionList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerAddUpdateDivisionListsuccess(res.data));
                    break;
                default:
                    dispatch(dealerAddUpdateDivisionListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERADDUPDATEDIVISONLIST,
                payload: err
            });
        });
}

function dealerAddUpdateDivisionListsuccess(data) {
    return {
        type: DEALERADDUPDATEDIVISONLIST_SUCCESS,
        payload: data
    };
}
function dealerAddUpdateDivisionListFailed(data) {
    return {
        type: DEALERADDUPDATEDIVISONLIST_FAILED,
        payload: data
    };
}

export { resetDealerAddUpdateDivisionList, dealerAddUpdateDivisonList }